import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";
import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons/faExclamationTriangle";

import { useClient, DELETE } from "@peracto/client";
import { toast } from "react-toastify";
import { bool } from "prop-types";
import { FormActions, Modal, Form } from "@peracto/peracto-ui";
import { WarrantyFormContent } from "./WarrantyFormContent";

const DEFAULT_VALUES = {
    firstName: "",
    lastName: "",
    email: "",
    placeOfPurchase: "",
    dateOfPurchase: "",
    productNameAndModel: "",
    serialNumber: "",
    productAccessories: "",
    installedBy: "",
    installerName: "",
    countryCode: "",
};

const WarrantyForm = ({
    data,
    modeAdd = false,
    modeEdit = false,
    ...props
}) => {
    const { client } = useClient();
    const [redirect, setRedirect] = useState();
    const [modalOpen, toggleModal] = useState(false);

    const onDelete = async () => {
        try {
            await client(DELETE, "warranty-registrations", {
                id: data.id,
            });

            toast.success("Warranty registration deleted successfully!");
            setRedirect("/warranty-registrations");
        } catch (e) {
            console.error(e);
            toast.error(
                e?.error?.body?.hasOwnProperty("hydra:description")
                    ? e.error.body["hydra:description"]
                    : "Whoops, there was a problem...",
            );
        }
    };

    return (
        <>
            {redirect && <Redirect to={redirect} />}

            <FormActions
                children={
                    modeEdit ? (
                        <button
                            className="btn btn--outline-primary text-danger"
                            onClick={() => toggleModal(!modalOpen)}
                        >
                            <FontAwesomeIcon icon={faTrash} className="mr-2" />
                            Delete Warranty Registration
                        </button>
                    ) : null
                }
            />
            <Form
                autoComplete="false"
                values={{
                    ...DEFAULT_VALUES,
                    ...data,
                }}
                {...props}
            >
                <WarrantyFormContent />
            </Form>

            {modeEdit && (
                <Modal
                    isVisible={modalOpen}
                    title="Delete Warranty Registration"
                    close={() => toggleModal(!modalOpen)}
                    buttons={[
                        {
                            type: "btn-outline-secondary",
                            text: "Close",
                            action: () => toggleModal(!modalOpen),
                        },
                        {
                            type: "btn-danger",
                            text: "Delete Warranty Registration",
                            action: () => onDelete(),
                        },
                    ]}
                >
                    <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        size="4x"
                        className="d-block mb-4"
                    />
                    Are you sure you would like to permanently delete this
                    warranty registration? Deleted warranty registrations cannot
                    be recovered.
                </Modal>
            )}
        </>
    );
};

WarrantyForm.propTypes = {
    modeAdd: bool,
    modeEdit: bool,
};

export default WarrantyForm;
